import React, { useEffect } from "react";
import "../styles/components/about-page.scss";
import ImageSlideshow from "../components/ImageSlideshow";
import PageHeader from "../components/PageHeader";

const AboutPage: React.FC = () => {
	// Team member data with updated information
	const teamMembers = [
		{
			id: 1,
			name: "Niki Tamjidi",
			position: "Co-Founder",
			role: "Tournament Manager",
			bio: "",
			image: "/images/team/nikitamjidi.png",
		},
		{
			id: 2,
			name: "Kaspar Adamsen",
			position: "Co-Founder",
			role: "Tournament Manager",
			bio: "",
			image: "/images/team/kasparadamsen.png",
		},
		{
			id: 3,
			name: "Daniel Schouw Jensen",
			position: "Co-Founder",
			role: "Commercial Manager",
			bio: "",
			image: "/images/team/danielschouw.png",
		},
		{
			id: 4,
			name: "Thomas Daugbjerg",
			position: "Co-Founder",
			role: "Commercial Manager",
			bio: "",
			image: "/images/team/thomasdaugbjerg.png",
		},
		{
			id: 5,
			name: "Casper Børsting",
			position: "Co-Founder",
			role: "Tech lead / Stats Wizard",
			bio: "",
			image: "/images/team/Casper.png",
		},
	];

	// Images for the mission slideshow
	const missionImages = [
		{
			src: "/images/slideshow/DSC02374.JPG",
			alt: "NCS Tournament",
		},
		{
			src: "/images/slideshow/DSC02363.JPG",
			alt: "Tournament in action",
		},
		{
			src: "/images/slideshow/DSC02369.JPG",
			alt: "Danish CS talents",
		},
		{
			src: "/images/slideshow/DSC02372.JPG",
			alt: "Team celebration",
		},
		{
			src: "/images/slideshow/DSC02377.JPG",
			alt: "NCS tournament venue",
		},
	];

	useEffect(() => {
		// Set page title
		document.title = "About Us | Northern Championships Series";
		// Scroll to top on page load
		window.scrollTo(0, 0);
	}, []);

	return (
		<div className="about-page">
			<PageHeader
				title="ABOUT US"
				subtitle="Meet the team behind Northern Championships Series and learn about our mission to grow the Nordic esports scene"
			/>

			{/* Mission Section */}
			<section className="mission-section">
				<div className="container">
					<div className="mission-content">
						<div className="mission-text">
							<h2>Our Mission</h2>
							<p>
								Established in 2024, we are dedicated to creating a premier LAN
								experience for the Nordic amateur and semi-professional esports
								scene. Our mission is to provide a platform where talented
								players can showcase their skills, experience the thrill of live
								competition, and take their game to the next level.
							</p>
							<p>
								Esports is more than just gaming—it’s about community,
								competition, and the electrifying atmosphere of a live event.
								LAN tournaments offer the intensity and camaraderie that online
								play simply can’t replicate, creating unforgettable moments for
								players and spectators alike.
							</p>
							<p>
								We aim to provide an environment that reflects the pressure and
								excitement of professional tournaments, giving emerging talent
								the opportunity to prove themselves. Every match is streamed
								live on Twitch, maximizing exposure to scouts, esports
								organizations, and the broader CS community.
							</p>
							<p>
								Passionate about growing the Nordic esports scene, we are here
								to give players the recognition they deserve. Whether you’re
								looking to test your abilities, gain visibility, or simply
								experience the thrill of LAN competition, we’re ready to make it
								happen.
							</p>
						</div>
						<div className="mission-image">
							<ImageSlideshow images={missionImages} autoplaySpeed={6000} />
						</div>
					</div>
				</div>
			</section>

			{/* Team Section */}
			<section className="team-section">
				<div className="container">
					<h2 className="section-title">Our Team</h2>
					<div className="team-grid">
						{teamMembers.map((member) => (
							<div key={member.id} className="team-member-card">
								<div className="member-image">
									<img src={member.image} alt={member.name} />
								</div>
								<div className="member-info">
									<h4>{member.name}</h4>
									<h5>
										{member.position} <br></br> {member.role}
									</h5>
									{member.bio && <p>{member.bio}</p>}
								</div>
							</div>
						))}
					</div>
				</div>
			</section>
		</div>
	);
};

export default AboutPage;
